import { useState, useEffect, useCallback, useMemo } from 'react';
import useTimer from '@customHooks/useTimer';
import useWindowSize from '@customHooks/useWindowSize';

const useReviewProductModal = ({
  editRating,
  commentType,
  isEditProductReview,
  onCloseModal,
  setCurrentFormState,
  currentFormState,
  itemId,
  updateOrdersAfterSubmitReturnForm
}) => {
  const { timer, activateTimer } = useTimer(2, false);
  const { isMobile } = useWindowSize();
  const [rating, setRating] = useState(editRating || 0);
  const [badRatingReviewType, setBadRatingReviewType] = useState('refund');
  useEffect(() => {
    if (commentType === 'Comment') {
      setCurrentFormState(1);
    }
  }, [commentType]);
  useEffect(() => {
    if (currentFormState === 2) {
      activateTimer();
    }
  }, [currentFormState]);
  useEffect(() => {
    if (timer === 0) {
      onCloseModal && onCloseModal();
    }
  }, [timer]);

  const onRateHandler = useCallback(
    stars => {
      setRating(stars);
      setCurrentFormState(1);
    },
    [setCurrentFormState]
  );
  const changeFormStateAfterSuccessReturnSubmit = useCallback(() => {
    updateOrdersAfterSubmitReturnForm && updateOrdersAfterSubmitReturnForm();
    setCurrentFormState(2);
  }, []);
  const onBadRatingTypeClickHandler = useCallback(
    type => setBadRatingReviewType(type),
    []
  );
  const onSuccessfullMessageSend = useCallback(
    () =>
      updateOrdersAfterSubmitReturnForm &&
      updateOrdersAfterSubmitReturnForm(itemId),
    [updateOrdersAfterSubmitReturnForm, itemId]
  );
  const heading = useMemo(
    () =>
      isEditProductReview
        ? `Редактировать ${commentType === 'Review' ? 'отзыв' : 'вопрос'}`
        : 'Вам понравился товар?',
    [isEditProductReview, commentType]
  );
  const isRatingBad = rating < 4;
  const subHeading = useMemo(
    () =>
      isEditProductReview
        ? `Редактировать ${commentType === 'Review' ? 'отзыв' : 'вопрос'}`
        : isRatingBad
        ? 'Что было не так?'
        : 'Что понравилось?',
    [isEditProductReview, isRatingBad, commentType]
  );
  return {
    state: {
      rating,
      isMobile,
      badRatingReviewType
    },
    functions: {
      onRateHandler,
      changeFormStateAfterSuccessReturnSubmit,
      onBadRatingTypeClickHandler,
      onSuccessfullMessageSend
    },
    misc: {
      isRatingBad,
      heading,
      subHeading
    }
  };
};

export default useReviewProductModal;
